import { cutToast } from 'utility/toast';
import { useMutation } from '@apollo/client';
import { BlockBlobClient } from '@azure/storage-blob';
import { PayCycleAvailableDocumentTypes } from 'ap/paymentCycle/__generated__/PayCycleAvailableDocumentTypes';
import {
  PayCycleUploadDocument,
  PayCycleUploadDocumentVariables,
  PayCycleUploadDocument_payCycleUploadDocument,
} from 'ap/paymentCycle/__generated__/PayCycleUploadDocument';
import { UploadFiles } from 'common/components/UploadFiles';
import { DocumentTypeOption } from 'common/components/UploadFiles/view';
import React from 'react';

import { AttachSectionProps } from '..';
import PAYCYCLE_UPLOAD_DOCUMENT from '../../../../../../PayCycleUploadDocument.graphql';

export type UploadFormProps = Pick<AttachSectionProps, 'paymentCycle'> & {
  availableDocumentTypes: PayCycleAvailableDocumentTypes | undefined;
  onUpload?: (
    fileSelected: File,
    documentData: PayCycleUploadDocument_payCycleUploadDocument,
    toastId: string
  ) => void;
};

export const UploadForm: React.FC<UploadFormProps> = ({
  availableDocumentTypes,
  paymentCycle,
  onUpload,
}) => {
  const [uploadDocument] = useMutation<
    PayCycleUploadDocument,
    PayCycleUploadDocumentVariables
  >(PAYCYCLE_UPLOAD_DOCUMENT, { errorPolicy: 'all' });

  const { isDraft, id } = { ...paymentCycle?.payCycle };
  const documentTypeOptions =
    availableDocumentTypes?.payCycleAvailableDocumentTypes?.nodes.map(
      (doctype) =>
        ({
          key: doctype.id,
          text: doctype.documentType || '',
          isAccountingDocument: doctype.isAccountingDocument,
          extractionTypes: doctype.extractionTypes,
          title:
            isDraft && doctype.isAccountingDocument
              ? 'Upload prohibited during/after the approval process'
              : undefined,
          disabled: (!isDraft && doctype.isAccountingDocument) || undefined,
        }) as DocumentTypeOption
    ) || [];
  return (
    <UploadFiles
      documentTypes={documentTypeOptions!}
      uploadDocument={{
        uploadDocumentData: async (documentType, data, filSelected) => {
          filSelected.map(async (fileEntity, fileIndex) => {
            // const toastId = `file.name.${fileEntity?.name}.${fileIndex}`;
            const toastId = cutToast.info(`Uploading ${fileEntity?.name}...`);
            const uploadMutationResults = await uploadDocument({
              variables: {
                document: {
                  ...data,
                  documentTypeId: parseInt(documentType.key.toString()),
                  filename: fileEntity.name,
                },
                payCycleId: id!,
              },
            });
            if (uploadMutationResults.errors) {
              cutToast.error(`Upload of ${fileEntity.name} failed`, {
                id: toastId,
              });
            }
            if (
              uploadMutationResults.data?.payCycleUploadDocument?.document &&
              uploadMutationResults.data?.payCycleUploadDocument?.document
                ._documentFileId
            ) {
              onUpload?.(
                fileEntity,
                uploadMutationResults.data?.payCycleUploadDocument,
                toastId!
              );
              const client = new BlockBlobClient(
                uploadMutationResults.data?.payCycleUploadDocument?.uploadLink
              );
              await client.uploadData(fileEntity);
            }
          });
        },
      }}
      // disableUpload={dirty}
    />
  );
};
